import { Loader2 } from 'lucide-react';
import { useLineageStore } from '@/stores/lineage';
import { LineageChainViz } from '@/components/knowledge/fleet/LineageChainViz';

export function LineageChainDetail() {
  const { chain, chainLoading, selectedRoot } = useLineageStore();

  if (chainLoading && !chain) {
    return (
      <div className="h-full flex items-center justify-center text-slate-400">
        <Loader2 size={16} className="animate-spin mr-2" />
        Loading chain...
      </div>
    );
  }

  if (!selectedRoot) {
    return (
      <div className="h-full flex items-center justify-center text-sm text-slate-400">
        Select a root to view the research chain
      </div>
    );
  }

  if (!chain) {
    return (
      <div className="h-full flex items-center justify-center text-sm text-slate-400">
        No chain data available for this root.
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="px-6 py-4 border-b border-slate-200">
        <h2 className="text-lg font-semibold text-navy-900">
          {chain.root.label ||
            chain.root.research_type ||
            chain.root.target_entity_name ||
            'Research chain'}
        </h2>
        <div className="flex items-center gap-3 mt-1 text-xs text-slate-500">
          <code>{chain.root.id}</code>
          {chain.root.client_id && <span>client: {chain.root.client_id}</span>}
          <span>depth {chain.total_depth}</span>
        </div>
      </div>

      <div className="flex-1 overflow-auto px-6 py-4">
        <LineageChainViz chain={chain} />
      </div>
    </div>
  );
}
